import { ChainId, Token, WETH } from "../../../libs/uniswap";
export const PolygonAddresses = {
    TOKEN_RING: "0x9C1C23E60B72Bc88a043bf64aFdb16A02540Ae8f",
    TOKEN_KTON: "0xE21b9bDA4ECeF9e4652BC5C6863F731C2151Ef28",
    TOKEN_WETH: "0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270",
    ELEMENT_GOLD: "0x56746a8099a7e6D962802A23e01FeDdc1282cDAe",
    ELEMENT_WOOD: "0xe97C7F83ec91E29569f1a08De95ad3Bb0e8B6B3A",
    ELEMENT_WATER: "0x81989cD57271565DBFfe9807E917Afc098B30c9A",
    ELEMENT_FIRE: "0x8216981a3eF2b45C705119644D0D48AcF7d14472",
    ELEMENT_SOIL: "0x2D8822a54fe8966891cEF3aC5A29d3B916393739",
    GOLD_RUSH_RAFFLE: "0x2A672796BD2aEAc25183c52337d64eB67569B454",
    PVETEAM_PROXY: "0x7ad712F5ED6024cf0D5f02968c83109b815bCe55",
    MATERIAL_PROXY: "0x7361e8FeC95abCff2697DcFC7b65922D4ec0E8a1",
    MATERIALTAKEBACK_PROXY: "0x6B1Ca23089f5071B6556db54eB35d8C180425DD9",
    CRAFTBASE_PROXY: "0x444E4319dC2Db7E030A641682459044DD3D83D76",
    LAND_CLOCK_AUCTION: "0x013b4f7e1C988d428a2183bCF158D2584F76A6D7",
    APOSTLE_CLOCK_AUCTION: "0x852b7223270E2776Dd0C137541b354cB8547bfc0",
    SIRING_CLOCK_AUCTION: "0xFdBEad883e975d92FbA03919a69b9A3A7EB9115B",
    APOSTLE_BASE: "0x58dff37A4682321650102DBa6D0B547BB647B798",
    LAND_RESOURCE: "0xe8f06b4193cE6E32208Cf209e7B45b717FF3980a",
    TOKEN_USE: "0xdaE9d5E41119EacEba2a12B1bE5825e2D39DaC3d",
    OBJECTOWNERSHIP: "0x41F4845d0ed269f6205D4542A5165255a9D6E8Cf",
    SETTINGSREGISTRY: "0x4d8765f1692e525E6f5572Ad141391dCF50D4A91",
    POINTS_REWARD_POOL: "0xEd969c03e8881371754231FE1C8f1D4fE4AF2082",
    TOKEN_USER_POINTS: "0xFB371c8B99ba0b239E66E0a66bB6296b00dCD09f",
    FURNACE_TREASURE: "0xC9161daEe118BcA99F82AB298D8A3Fc4AdD6118F",
    FURNACE_ITEM_BASE: "0xeeF1549070592904b028BEAC9AcC89dDdEa83ae6",
    FURNACE_TAKEBACK: "0x55c84924bD832F870B225374dF835F05c35A4fc7",
    UNISWAP_EXCHANGE: "0xa5E0829CaCEd8fFDD4De3c43696c57F7D7A678ff",
    STAKINGREWARDSFACTORY: "0xC0a8CdAedF3acdaD7da8a8CA289C811b93519e0b",
    GOLDRAFFLEPOOL_PROXY: "0x69716bb8879D2f4E56e05b37f957B7F3Bf39e26d",
    WOODRAFFLEPOOL_PROXY: "0xB287aa380013B1d89279E8cC73C97a65d5543894",
    WATERRAFFLEPOOL_PROXY: "0x0787391e5Bca02da1B9902B801d57b5a1d662BCa",
    FIRERAFFLEPOOL_PROXY: "0xd5332E20970EdA1549BdC5AAa6e1Aa8857d264fA",
    SOILRAFFLEPOOL_PROXY: "0xCDD7E27abBF54D2626c49c21FbdEE6dAb394b416",
};
export const PolygonTokens = {
    RING: new Token(ChainId.POLYGON, PolygonAddresses.TOKEN_RING, 18, "RING", "Darwinia Network Native Token"),
    KTON: new Token(ChainId.POLYGON, PolygonAddresses.TOKEN_KTON, 18, "KTON", "Darwinia Network Commitment Token"),
    GOLD: new Token(ChainId.POLYGON, PolygonAddresses.ELEMENT_GOLD, 18, "GOLD", "Evolution Land Token"),
    WOOD: new Token(ChainId.POLYGON, PolygonAddresses.ELEMENT_WOOD, 18, "WOOD", "Evolution Land Token"),
    WATER: new Token(ChainId.POLYGON, PolygonAddresses.ELEMENT_WATER, 18, "WATER", "Evolution Land Token"),
    FIRE: new Token(ChainId.POLYGON, PolygonAddresses.ELEMENT_FIRE, 18, "FIRE", "Evolution Land Token"),
    SOIL: new Token(ChainId.POLYGON, PolygonAddresses.ELEMENT_SOIL, 18, "SOIL", "Evolution Land Token"),
    WETH: WETH[ChainId.POLYGON],
};
